import React from "react";
import PropTypes from "prop-types";
import { defaultProps } from "recompose";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";


const HorizontalLabelStepper = ({id, data, steps, stepName, history}) => {
    const [state, setState] = React.useState({
        activeStep: 0,
        data: null,
        parentData: data
    });

    const handleNext = (data) => {
        setState(prevState => ({
            ...prevState,
            activeStep: prevState.activeStep + 1,
            data: data,
        }))
    }
    const handleBack = (data) => {
        console.log("handleBack 2")
        console.log(state)
        console.log(data)
        setState(prevState => ({
            ...prevState,
            activeStep: prevState.activeStep - 1,
            data: data,
        }))
    }
    const handleReset = () => {
        setState({
            parentData: data,
            activeStep: 0,
            data: null,
        })
    }
    const handleGoto = (stepId) => {
        setState(prevState => ({
            ...prevState,
            activeStep: stepId,
        }))
    }


    const stepsList = steps.getSteps();
    const nbStep = steps.getSteps().length;
    const step = steps.getStepContent(state.activeStep);

    const extraProps = steps.getExtraProps(state.activeStep);

    return <div>
        <div className="hideOn600">
            <Stepper activeStep={state.activeStep} alternativeLabel>
                {
                    stepsList.map(label => <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>)
                }
            </Stepper>
        </div>

        <div>
            {
                React.cloneElement(
                    step,
                    {
                        handleNext: handleNext,
                        handleBack: handleBack,
                        activeStep: state.activeStep,
                        nbStep: nbStep,
                        stepName: stepName,
                        data: state.data,
                        id: id,
                        parentData: state.parentData,
                        history: history,
                        ...extraProps
                    }
                )
            }
        </div>
    </div>
};


HorizontalLabelStepper.propTypes = {
    steps: PropTypes.object.isRequired,
    stepName: PropTypes.string.isRequired
}


HorizontalLabelStepper.widthDefaultProps = defaultProps({
    steps: {},
    stepName: ''
})
export default HorizontalLabelStepper
